import { useTranslation } from "react-i18next";
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
export default function Footer({
  lang,
  toggleLanguage
}) {
  const {
    t
  } = useTranslation();
  const navigate = useNavigate();
  return <>
      <footer className="bg-[#0f172a] text-white pt-24 pb-12 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.03] mix-blend-overlay"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/20 blur-[120px] rounded-full pointer-events-none z-0"></div>

        <div className="max-w-[1440px] mx-auto px-12 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-12 mb-16">

            {/* Brand Column */}
            <div className="flex flex-col items-center text-center">
              <Link to="/" className="flex items-center justify-center mb-4 group">
                <img 
                  src={process.env.PUBLIC_URL + "/images/ello%20logo%20vertical%20b&w.svg"} 
                  alt={t("footer_text_567")} 
                  className="h-20 md:h-24 lg:h-[100px] w-auto object-contain -mt-2 hover:scale-105 transition-transform duration-300 filter drop-shadow-[0_4px_12px_rgba(0,0,0,0.85)] brightness-110"
                />
              </Link>
              <p className="font-body text-slate-400 text-sm leading-relaxed mb-4">
                <span dangerouslySetInnerHTML={{
                __html: t("footer_span_569")
              }} />
                
              </p>
              <a href="tel:+15143645715" className="inline-flex items-center gap-2 text-slate-300 transition-all duration-300 mb-2.5 px-4 py-2 rounded-full border border-white/10 hover:bg-white hover:text-[#0f172a]">
                <span className="material-symbols-outlined text-base">call</span>
                <span className="font-manrope text-sm font-bold">+1 514 364 5715</span>
              </a>
              <a href="mailto:support@ello.ca" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-xs font-semibold mb-2.5">
                <span className="material-symbols-outlined text-sm">mail</span>
                <span>support@ello.ca</span>
              </a>
              <p className="text-[11px] text-slate-400 font-medium mb-6 max-w-[240px]">
                5993 Rue Jean-Talon E #202,<br />Saint-Léonard, QC H1S 1M5
              </p>
              <div className="flex items-center gap-4">
                <Link to="/" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-colors text-slate-300 hover:text-white"><span className="font-bold text-sm">{t("footer_text_571")}</span></Link>
                <Link to="/" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-colors text-slate-300 hover:text-white"><span className="font-bold text-sm">{t("footer_text_572")}</span></Link>
                <Link to="/" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-colors text-slate-300 hover:text-white"><span className="font-bold text-sm">{t("footer_text_573")}</span></Link>
                <Link to="/" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-colors text-slate-300 hover:text-white"><span className="font-bold text-sm">{t("footer_text_574")}</span></Link>
              </div>
            </div>

            {/* Column 2: Get Insurance (Spans 2 columns) */}
            <div className="flex flex-col items-center text-center lg:col-span-2">
              <h4 className="font-headline font-bold text-white mb-6 uppercase text-xs tracking-[0.15em] opacity-80">
                <span dangerouslySetInnerHTML={{
                __html: t("footer_span_575")
              }} />
              </h4>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 w-full">
                {/* Replacement Insurance */}
                <li className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-all w-max min-w-full group relative overflow-visible">
                  <span className="absolute -top-1.5 -right-2 bg-gradient-to-r from-[#B8860B] to-[#D4AF37] text-white text-[5px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full shadow-[0_2px_8px_rgba(212,175,55,0.3)] z-20 animate-breath">
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_576")
                  }} />
                    
                  </span>
                  <div className="flex items-center gap-2">
                    <Link to="/products/replacement-insurance" onClick={() => window.scrollTo(0, 0)} className="font-body font-bold text-sm text-white hover:text-primary transition-colors">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_577")
                    }} />
                      
                    </Link>
                  </div>
                  <div className="flex gap-4">
                    <button onClick={() => {
                    navigate('/products/replacement-insurance/quote');
                    window.scrollTo(0, 0);
                  }} className="text-[10px] uppercase tracking-wider font-bold text-slate-400 hover:text-tertiary-fixed transition-colors whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_578")
                    }} />
                      
                    </button>
                    <Link to="/claims/replacement-insurance" onClick={() => window.scrollTo(0, 0)} className="text-[10px] uppercase tracking-wider font-bold text-slate-400 hover:text-tertiary-fixed transition-colors whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_579")
                    }} />
                      
                    </Link>
                  </div>
                </li>

                {/* Travel Insurance */}
                <li className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-all w-max min-w-full group relative overflow-visible">
                  <span className="absolute -top-1.5 -right-2 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-indigo-600 text-white text-[5px] font-black uppercase tracking-[0.15em] shadow-lg z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-1 h-1 rounded-full bg-indigo-200 animate-pulse"></span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_580")
                  }} />
                    
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="font-body font-bold text-sm text-white">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_581")
                    }} />
                      
                    </span>
                  </div>
                  <div className="flex gap-4 opacity-40">
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_582")
                    }} />
                      
                    </div>
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_583")
                    }} />
                      
                    </div>
                  </div>
                </li>

                {/* Cyber Insurance */}
                <li className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-all w-max min-w-full group relative overflow-visible">
                  <span className="absolute -top-1.5 -right-2 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-indigo-600 text-white text-[5px] font-black uppercase tracking-[0.15em] shadow-lg z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-1 h-1 rounded-full bg-indigo-200 animate-pulse"></span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_584")
                  }} />
                    
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="font-body font-bold text-sm text-white">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_585")
                    }} />
                      
                    </span>
                  </div>
                  <div className="flex gap-4 opacity-40">
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_586")
                    }} />
                      
                    </div>
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_587")
                    }} />
                      
                    </div>
                  </div>
                </li>

                {/* Boat Insurance */}
                <li className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-all w-max min-w-full group relative overflow-visible">
                  <span className="absolute -top-1.5 -right-2 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-indigo-600 text-white text-[5px] font-black uppercase tracking-[0.15em] shadow-lg z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-1 h-1 rounded-full bg-indigo-200 animate-pulse"></span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_588")
                  }} />
                    
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="font-body font-bold text-sm text-white">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_589")
                    }} />
                      
                    </span>
                  </div>
                  <div className="flex gap-4 opacity-40">
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_590")
                    }} />
                      
                    </div>
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_591")
                    }} />
                      
                    </div>
                  </div>
                </li>

                {/* Event Insurance */}
                <li className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-all w-max min-w-full group relative overflow-visible">
                  <span className="absolute -top-1.5 -right-2 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-indigo-600 text-white text-[5px] font-black uppercase tracking-[0.15em] shadow-lg z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-1 h-1 rounded-full bg-indigo-200 animate-pulse"></span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_592")
                  }} />
                    
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="font-body font-bold text-sm text-white">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_593")
                    }} />
                      
                    </span>
                  </div>
                  <div className="flex gap-4 opacity-40">
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_594")
                    }} />
                      
                    </div>
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_595")
                    }} />
                      
                    </div>
                  </div>
                </li>

                {/* Sports Insurance */}
                <li className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-all w-max min-w-full group relative overflow-visible">
                  <span className="absolute -top-1.5 -right-2 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-indigo-600 text-white text-[5px] font-black uppercase tracking-[0.15em] shadow-lg z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-1 h-1 rounded-full bg-indigo-200 animate-pulse"></span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_596")
                  }} />
                    
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="font-body font-bold text-sm text-white">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_597")
                    }} />
                      
                    </span>
                  </div>
                  <div className="flex gap-4 opacity-40">
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_598")
                    }} />
                      
                    </div>
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_599")
                    }} />
                      
                    </div>
                  </div>
                </li>

                {/* RBQ Surety Bonds */}
                <li className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-all w-max min-w-full group relative overflow-visible">
                  <span className="absolute -top-1.5 -right-2 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-indigo-600 text-white text-[5px] font-black uppercase tracking-[0.15em] shadow-lg z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-1 h-1 rounded-full bg-indigo-200 animate-pulse"></span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_600")
                  }} />
                    
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="font-body font-bold text-sm text-white">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_601")
                    }} />
                      
                    </span>
                  </div>
                  <div className="flex gap-4 opacity-40">
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_602")
                    }} />
                      
                    </div>
                    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 cursor-not-allowed whitespace-nowrap shrink-0 w-max">
                      <span dangerouslySetInnerHTML={{
                      __html: t("footer_span_603")
                    }} />
                      
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            {/* Column 3: Learn More */}
            <div className="flex flex-col items-center text-center">
              <h4 className="font-headline font-bold text-white mb-6 uppercase text-xs tracking-[0.15em] opacity-80">
                <span dangerouslySetInnerHTML={{
                __html: t("footer_span_604")
              }} />
              </h4>
              <ul className="flex flex-col gap-1 items-center w-full">
                <li className="w-full"><Link to="/blogs" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_605")
                  }} /></Link></li>
                <li className="w-full"><Link to="/faqs" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_606")
                  }} /></Link></li>
                <li className="w-full"><Link to="/blogs?category=news" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_607")
                  }} /></Link></li>
                <li className="w-full"><Link to="/blogs?category=tips" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_608")
                  }} /></Link></li>
                <li className="w-full"><Link to="/blogs?category=guides" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_609")
                  }} /></Link></li>
              </ul>
            </div>

            {/* Column 4: Get In Touch */}
            <div className="flex flex-col items-center text-center">
              <h4 className="font-headline font-bold text-white mb-6 uppercase text-xs tracking-[0.15em] opacity-80">
                <span dangerouslySetInnerHTML={{
                __html: t("footer_span_610")
              }} />
              </h4>
              <ul className="flex flex-col gap-1 items-center w-full">
                <li className="w-full"><Link to="/about-us" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_611")
                  }} /></Link></li>
                <li className="w-full"><Link to="/contact-us" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_612")
                  }} /></Link></li>
                <li className="w-full"><Link to="/compliments-and-complaints" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_613")
                  }} /></Link></li>
                <li className="w-full"><Link to="/partner-with-us" className="block w-full p-2 rounded-xl hover:bg-white/5 transition-all font-body text-slate-300 hover:text-white text-sm"><span dangerouslySetInnerHTML={{
                    __html: t("footer_span_614")
                  }} /></Link></li>
              </ul>
            </div>


          </div>

          <div className="pt-12 border-t border-white/10 flex flex-col">
            {/* ROW 1: AMF Registered | Legal Links | Language Toggle */}
            <div className="flex flex-col xl:flex-row justify-between items-center gap-6 pb-2">
              
              {/* Left: AMF Registered Badge Container */}
              <div className="w-full xl:w-[320px] flex justify-center xl:justify-center shrink-0">
                <div className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-emerald-900/40 to-emerald-800/20 border border-emerald-500/40 px-5 py-2.5 rounded-xl text-xs uppercase tracking-[0.2em] font-black text-emerald-300 shadow-[0_0_25px_rgba(16,185,129,0.2)] relative overflow-hidden group">
                  <div className="absolute inset-0 bg-emerald-400/5 animate-[pulse_2s_ease-in-out_infinite]"></div>
                  {/* Heartbeat / Ping Indicator */}
                  <div className="relative flex items-center justify-center shrink-0">
                    <span className="absolute inline-flex h-4 w-4 rounded-full bg-emerald-400 opacity-75 animate-ping"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
                  </div>
                  <span className="material-symbols-outlined text-[22px] text-emerald-400 relative z-10 drop-shadow-[0_0_8px_rgba(52,211,153,0.8)]">verified</span>
                  <span className="relative z-10">
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_615")
                  }} />
                    
                  </span>
                </div>
              </div>

              {/* Center: Legal Links */}
              <div className="flex flex-wrap justify-center gap-x-6 gap-y-4 w-full xl:flex-1">
                <Link to="/legal/terms-of-use" className="text-[10px] font-bold uppercase tracking-widest text-slate-400 hover:text-white transition-colors">
                  <span dangerouslySetInnerHTML={{
                  __html: t("footer_span_616")
                }} />
                </Link>
                <Link to="/legal/privacy-policy" className="text-[10px] font-bold uppercase tracking-widest text-slate-400 hover:text-white transition-colors">
                  <span dangerouslySetInnerHTML={{
                  __html: t("footer_span_617")
                }} />
                </Link>
                <Link to="/legal/cookie-policy" className="text-[10px] font-bold uppercase tracking-widest text-slate-400 hover:text-white transition-colors">
                  <span dangerouslySetInnerHTML={{
                  __html: t("footer_span_618")
                }} />
                </Link>
                <Link to="/legal/payment-agreements" className="text-[10px] font-bold uppercase tracking-widest text-slate-400 hover:text-white transition-colors">
                  <span dangerouslySetInnerHTML={{
                  __html: t("footer_span_619")
                }} />
                </Link>
              </div>

              {/* Right: Language Toggle Container */}
              <div className="w-full xl:w-[150px] flex justify-center xl:justify-center shrink-0">
                <div className="flex items-center scale-90">
                  <label className="inline-flex items-center cursor-pointer">
                    <span className={`mr-2 text-xs font-bold transition-all duration-300 ${lang === 'fr' ? 'text-primary' : 'text-white/70'}`}>{t("footer_text_621")}</span>
                    <div className="relative">
                      <input className="sr-only peer lang-toggle-checkbox" onChange={toggleLanguage} checked={lang === 'en'} type="checkbox" />
                      <div className="w-9 h-5 bg-white/20 border border-white/10 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-[100%] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary nav-toggle-track"></div>
                    </div>
                    <span className={`ml-2 text-xs font-bold transition-all duration-300 ${lang === 'en' ? 'text-primary' : 'text-white/70'}`}>{t("footer_text_620")}</span>
                  </label>
                </div>
              </div>
            </div>

            {/* ROW 2: AMF Licensed | Copyright | SSL Secured */}
            <div className="flex flex-col xl:flex-row justify-between items-center gap-6 pt-2">
              
              {/* Left: AMF Licensed Container */}
              <div className="w-full xl:w-[320px] flex justify-center xl:justify-center shrink-0">
                <div className="flex items-center gap-1.5 text-slate-300 transition-all cursor-default">
                  <span className="material-symbols-outlined text-sm text-primary">shield</span>
                  <span className="text-[10px] font-bold uppercase tracking-widest flex items-center gap-1">
                    <span dangerouslySetInnerHTML={{
                    __html: t("footer_span_622")
                  }} />
                    
                    <span className="text-slate-500 ml-1">{t("footer_text_623")}</span>
                    <a href="https://lautorite.qc.ca/en/general-public/registers/register-of-firms-and-individuals-authorized-to-practice" target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:text-sky-300 hover:underline transition-colors">
                      505298
                    </a>
                    <span className="text-slate-500">)</span>
                  </span>
                </div>
              </div>

              {/* Center: Copyright */}
              <div className="w-full xl:flex-1 flex justify-center">
                <p className="font-body text-slate-300 text-[10px] uppercase tracking-widest text-center">
                  &copy; {new Date().getFullYear()} {t("footer_text_624")}</p>
              </div>

              {/* Right: SSL Secured Container */}
              <div className="w-full xl:w-[150px] flex justify-center xl:justify-center shrink-0">
                <div className="flex items-center gap-2 text-slate-300 transition-all cursor-default">
                  <span className="material-symbols-outlined text-sm text-green-400">lock</span>
                  <span className="text-[10px] font-bold uppercase tracking-widest whitespace-nowrap">{t("footer_text_625")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

    </>;
}